export const buildBotPath = (botId: string | undefined, path: string) => {
    const resolvedBotId = botId || '1';
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `/${resolvedBotId}${normalizedPath}`;
};
